export const FunctionRegistry = {
    removeQueryParamsFromUrl: null as null | (() => void),
};